var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3"},[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-subtitle',{staticClass:"font-weight-bold"},[_vm._v("Total: "+_vm._s(_vm.totalValue))]),_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('canvas',{staticClass:"my-canvas",attrs:{"id":_vm.id}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }